<template>
  <div class="cp-empty">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'cpEmpty',

  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.cp-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
